module.exports = __webpack_public_path__ + "img/icon_animal_plants.80f2f3e.svg";